/**
 * reportTicket模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const reportTicket = {
  //运维工作添加
  addReportTicket(params) {
    return $http.post(`${global.API_URL}/sme/reportTicket/add`,params);
  },
  //运维工作删除
  deleteReportTicket(params) {
    return $http.post(`${global.API_URL}/sme/reportTicket/delete`,params);
  },
  //查询运维报告案例列表
  selectReportTicketList(params) {
    return $http.post(`${global.API_URL}/sme/reportTicket/selectReportTicketList`,params);
  },
  //查询案例列表
  selectTicketList(params) {
    return $http.post(`${global.API_URL}/sme/reportTicket/selectTicketList`,params);
  },
  //查询预览案例图表接口
  selectPreviewByReportTicket(params) {
    return $http.post(`${global.API_URL}/sme/reportTicket/selectPreviewByReportTicket`,params);
  }
}

export default reportTicket;



// WEBPACK FOOTER //
// ./src/api/reportTicket.js